<template>
  <div class="graph-wrapper" ref="wrap">
    <div ref="knowledgeGraph" class="knowledge-graph"></div>
    <div class="btn-wrap" v-show="!chat.isFull">
      <!-- 全屏切换按钮 -->
      <svg ref="svgRef" t="1741750015662" class="icon screen-icon" :class="isFull ? 'full' : ''" @click="handleFull" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6479" width="200" height="200">
        <path d="M368.896 192H224a32 32 0 0 0-32 32v137.888a32 32 0 0 0 64 0V256h112.896a32 32 0 0 0 0-64zM784.864 192H640a32 32 0 1 0 0 64h112.864v105.888a32 32 0 1 0 64 0V224a32 32 0 0 0-32-32zM368.896 777.92H256V672a32 32 0 1 0-64 0v137.92a32 32 0 0 0 32 32h144.896a32 32 0 1 0 0-64zM784.864 640a32 32 0 0 0-32 32v105.92H640a32 32 0 1 0 0 64h144.864a32 32 0 0 0 32-32V672a32 32 0 0 0-32-32z" fill="#020202" p-id="6480"></path>
        <path d="M912 48h-800c-35.296 0-64 28.704-64 64v800c0 35.296 28.704 64 64 64h800c35.296 0 64-28.704 64-64v-800c0-35.296-28.704-64-64-64z m-800 864v-800h800l0.064 800H112z" fill="#020202" p-id="6481"></path>
      </svg>
      <!-- 布局切换按钮 -->
      <!-- 树形布局（三条横线） -->
      <svg v-if="layoutMode === 'center'" class="icon layout-icon" @click="toggleLayout" viewBox="0 0 1024 1024">
        <line x1="200" y1="280" x2="824" y2="280" stroke="currentColor" stroke-width="76" stroke-linecap="round"/>
        <line x1="200" y1="512" x2="640" y2="512" stroke="currentColor" stroke-width="76" stroke-linecap="round"/>
        <line x1="200" y1="744" x2="456" y2="744" stroke="currentColor" stroke-width="76" stroke-linecap="round"/>
      </svg>

      <!-- 环形布局（虚线圆 + 实心点） -->
      <svg v-else class="icon layout-icon" @click="toggleLayout" viewBox="0 0 1024 1024">
        <circle cx="512" cy="512" r="300" fill="none" stroke="currentColor" stroke-width="46" stroke-dasharray="60 120" stroke-linecap="round"/>
        <circle cx="512" cy="212" r="60" fill="currentColor"/>
        <circle cx="790" cy="565" r="60" fill="currentColor"/>
        <circle cx="568" cy="790" r="60" fill="currentColor"/>
        <circle cx="268" cy="620" r="60" fill="currentColor"/>
        <circle cx="512" cy="512" r="46" fill="currentColor"/>
      </svg>
      <!-- 带着地图学习按钮 -->
      <span class="icon advanced-icon" @click="showAdvanced = true">🗺️</span>
    </div>

    <!-- 图片放大 -->
    <ImageEnlarge
      v-if="isModalShow"
      :src="enlargeSrc"
      :style="{ zIndex: layer }"
      @close="isModalShow = false"
    />

    <AdvancedLearning
      v-if="showAdvanced"
      :kg-id="kgId"
      :paint-data="currentPaintData"
      @close="showAdvanced = false"
    />
  </div>
</template>

<script>
import chatMixin from "@/mixin/chat.js";
import graphRender from "@/mixin/graphRender";
import md from "@/utils/markdown/md";
import ImageEnlarge from "@/components/ImageEnlarge.vue";
import { getImageSrcFromHtml } from "@/utils/tool";
import { createAutoMsg } from "@/utils/chat/autoMsg";
import { mapState } from "vuex";
import AdvancedLearning from "@/components/AdvancedLearning.vue";

var modalLayer = 0;

export default {
  components: {
    ImageEnlarge,
    AdvancedLearning,
  },
  mixins: [chatMixin, graphRender],
  props: ["chat", "sessionId"],
  computed: {
    ...mapState(["robotId"]),
  },
  data() {
    return {
      showAdvanced: false,
      isModalShow: false,
      isFull: false,
      layer: 3000,
      enlargeSrc: "",
      kgId: "",
      // mixin 渲染所用的数据源（必须）
      currentPaintData: null,
      dataOption: {},
      resizeObserver: null,
    };
  },
  mounted() {
    this.currentPaintData = this.chat.paintData; // ← 关键：赋给 mixin 使用的数据源
    this.dataOption = this.chat.paintData;
    this.kgId = this.chat.kgId;
    this.initGraphSvg();
    this.initResizeObserver();
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
  methods: {
    // ===== mixin 钩子 =====
    getGraphContainer() {
      return this.$refs.knowledgeGraph;
    },
    async onNodeClick(d) {
      if (this.chat.isFull) return;
      if (this.isFull) {
        this.isFull = !this.isFull;
        this.draw(true);
      }
      let text = d.data.name;
      let robotId = this.robotId;
      let sessionId = this.sessionId;

      // 只创建 AI 消息，不显示用户消息
      let electricaiMsg = createAutoMsg(
        this.robots.knowledgeGraph.avatar,
        this.$delete
      );
      electricaiMsg.type = "graphCollect";
      electricaiMsg.params = {
        robotId,
        sessionId,
        text,
        fileList: [],
        kgid: this.kgId,
        clickName: text,
      };
      electricaiMsg.sessionId = sessionId;
      electricaiMsg.robotId = robotId;

      await this.$store.dispatch("addMessageToConversation", {
        message: electricaiMsg,
      });

      let paramsObj = {
        text,
        fileList: [],
        sessionId,
        robotId,
        answerUrl: "/api/kgNode2report",
        aiContent: electricaiMsg,
        clickName: text,
        kgid: this.kgId,
      };
      this.robots["graphCollect"].getStreamAnswer(paramsObj);
    },
    onNodeImageClick(d) {
      this.layer += ++modalLayer;
      this.isModalShow = true;
      this.enlargeSrc = getImageSrcFromHtml(md.render(d.data.image));
      this.$emit("handleGraphImagePreview", this.enlargeSrc);
    },

    // ===== 组件自身 =====
    handleFull() {
      this.isFull = !this.isFull;
      this.$nextTick(() => {
        this.draw(true);
      });
    },
    toggleLayout() {
      this.toggleGraphLayout();
    },
    closeAllModal() {
      let eles = document.querySelectorAll(".el-image-viewer__wrapper");
      eles && eles.forEach((ele) => (ele.style.display = "none"));
    },
    handleModal() {
      this.$emit("handleModal");
    },
    initResizeObserver() {
      this.resizeObserver = new ResizeObserver(() => {});
      this.resizeObserver.observe(this.$refs.wrap);
    },
  },
};
</script>

<style lang="scss" scoped>
.layout-icon {
  color: #020202;   // 默认黑色
  &:hover {
    color: #409eff; // 悬停时蓝色（可选）
  }
}
.graph-wrapper {
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  .top-section {
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;
    i {
      font-size: 40PX !important;
    }
  }
  &:has(.full) {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw !important;
    height: 100% !important;
    background-color: var(--markdown-bg-color);
    z-index: 1001;
    .graph-svg {
      width: 100% !important;
      height: 100% !important;
    }
    .knowledge-graph {
      width: 100%;
      height: 96%;
    }
  }
}
.knowledge-graph {
  width: 100%;
  height: 60vh;
}
.svg-wrap {
  height: calc(100% - 80PX);
}
.graph-svg-custom {
  width: 100%;
  height: calc(100% - 80PX);
}
.btn-wrap {
  position: absolute;
  bottom: 16px;
  right: 16px;
  z-index: 10;
  width: auto;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.85);
  box-shadow: 0 2px 10px rgba(204, 237, 252, 0.2);
  cursor: pointer;
  pointer-events: auto;
  margin: 0;
  padding: 4px;
  border-radius: 4px;
  svg {
    width: 32px;
    height: 32px;
    background-color: transparent;
    margin: 0 4px;
    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 0;
    }
  }
  .screen-icon {
    cursor: pointer;
    width: 32px;
    path {
      fill: rgb(92, 7, 250);
    }
  }
  .layout-icon {
    cursor: pointer;
    width: 32px;
    path {
      fill: #020202;
    }
  }
  .advanced-icon {
    cursor: pointer;
    font-size: 28px;          // 调节大小
    line-height: 1;
    color: #020202;           // 默认黑色
    transition: color 0.2s;

    &:hover {
      color: rgb(92, 7, 250); // 与原悬停效果保持一致
    }
  }
}
.node {
  width: max-content !important;
}
rect {
  height: max-content !important;
}
svg {
  transition: all 1s ease-in-out;
}
.toggle {
  transform: translate(0, -8PX) !important;
  font-size: 24PX !important;
  fill: #fff !important;
  text-shadow: 0 2PX 4PX rgba(0, 0, 0, 0.2);
  z-index: 100;
  &:hover {
    filter: brightness(1.2);
    transform: translate(0, -8PX) scale(1.1);
  }
}
::v-deep li:has(.katex) {
  line-height: 1.5 !important;
}
::v-deep p:has(.katex) {
  line-height: 1.5 !important;
}
.katex {
  display: inline-block;
  max-width: 100%;
  overflow-x: auto;
  white-space: normal !important;
}
.katex-html {
  white-space: normal !important;
  text-align: center;
}
</style>
